import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 30 30"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#3C492F",
  d: "M6.939 15.708a.95.95 0 0 1-.506.51 1.08 1.08 0 0 1-.75.044.98.98 0 0 1-.571-.448.85.85 0 0 1-.069-.687q.054-.152.124-.299c.08-.174.198-.414.36-.698a10.2 10.2 0 0 1 1.602-2.083C8.659 10.517 11.164 9 14.989 9s6.33 1.516 7.86 3.047a10 10 0 0 1 1.96 2.781l.092.207c.006.015.026.11.046.202l.04.18s.168.61-.684.869a1.1 1.1 0 0 1-.762-.049.95.95 0 0 1-.502-.527v-.006l-.012-.029a7 7 0 0 0-.344-.69 8.3 8.3 0 0 0-1.308-1.699c-1.22-1.219-3.213-2.453-6.386-2.453s-5.167 1.234-6.387 2.453a8.2 8.2 0 0 0-1.59 2.246l-.06.143zm8.05-3.041c-1.06 0-2.078.386-2.828 1.074-.75.687-1.171 1.62-1.171 2.592 0 .973.421 1.905 1.171 2.593S13.928 20 14.989 20s2.078-.386 2.828-1.074 1.17-1.62 1.17-2.593-.42-1.905-1.17-2.592-1.768-1.074-2.828-1.074m-2 3.666c0-.486.21-.952.586-1.296a2.1 2.1 0 0 1 1.414-.537c.53 0 1.039.193 1.414.537s.585.81.585 1.296c0 .487-.21.953-.585 1.297a2.1 2.1 0 0 1-1.414.537c-.53 0-1.04-.194-1.414-.537a1.76 1.76 0 0 1-.586-1.297"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }